import { Flex, FlexProps, Heading, HeadingProps } from '@chakra-ui/react'

interface ControlPanelElementProps {
	children: React.ReactNode
	title: string
	flexProps?: FlexProps
	headingProps?: HeadingProps
	onClick?: () => void
}
const ControlPanelElement: React.FC<ControlPanelElementProps> = ({
	children,
	flexProps = {} as unknown as FlexProps,
	headingProps = {} as unknown as HeadingProps,
	title,
	onClick,
}) => {
	return (
		<Flex
			onClick={onClick}
			minWidth={'8rem'}
			zIndex={11}
			alignItems={'center'}
			maxWidth={'8rem'}
			justifyContent="space-evenly"
			flexDir={'column'}
			{...flexProps}
		>
			<Heading
				alignSelf="auto"
				textAlign={'start'}
				color="blackAlpha.800"
				size={['xs', null, 'sm']}
				{...headingProps}
			>
				{title}
			</Heading>
			{children}
		</Flex>
	)
}

export default ControlPanelElement
